import React, { useContext, useState } from "react";
import VylabsIcon from "../../Assets/Images/VybogTAL-Logo.svg";
import vybogTALDarkLogo from "../../Assets/Images/VybogTAL-Logo-Dark.svg";
import accountIcon from "../../Assets/Images/accout-holder-icon.png";
import DynamicTextField from "../../Common/Textfield/Textfield";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneNumberInput from "../../Common/PhoneNumberInput/PhoneNumberInput";
import Button from "../../Common/Button/Button";
import "../Signup/Signup.css";
// import continueIcon from "../../Assets/Images/continue-arrow-icon.png";
import { DynamicContext } from "../../Context/DynamicContext";
import {
  VYLABS_BASE_URL,
  SIGNUP_URL,
  JOIN_FROM_INVITE_LINK,
} from "../../helper/url_helper";
import { post } from "../../helper/Api_helper";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
// import backIcon from "../../Assets/Images/arrow-right.png";
import { useSearchParams } from "react-router-dom";
import SignupCompletion from "../Signup/SignupCompletion";
import { TENANT_CORE_API_KEY, TENANT_OTP_API_KEY } from "../../Tenant-Config/TenantConfig";
import { getTimezone } from "../../Common/Time-Zone-Utils/timezoneUtils";

function UserJoinPage() {
  const {
    isSignupCompleted,
    setSignupPassword,
    setSignupEmail,
    setSignupCompleted,
    isDarkMode,
  } = useContext(DynamicContext);
  const [searchParams] = useSearchParams();
  const shareId = searchParams.get("id");
  const [isLoading, setIsLoading] = useState(false);
  const validationSchema = Yup.object().shape({
    firstname: Yup.string().required("First name is required"),
    lastname: Yup.string().required("Last name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email address"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(/^\+?[1-9]\d{1,14}$/, "Please enter a valid phone number"),
    newpassword: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
      ),
    confirmNewPassword: Yup.string()
      .required("Please confirm your password")
      .oneOf([Yup.ref("newpassword"), null], "Passwords must match"),
  });

  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      phoneNumber: "",
      newpassword: "",
      confirmNewPassword: "",
    },
    validationSchema: validationSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      if (formik.isValid) {
        memberSignup();
      } else {
        console.error("Form validation failed:", formik.errors);
      }
    },
  });

  const handlePhoneInputChange = React.useCallback(
    (phone) => {
      const formattedPhone = phone.startsWith("+") ? phone : `+${phone}`;
      formik.setFieldValue("phoneNumber", formattedPhone);
      formik.setFieldTouched("phoneNumber", true, false);
    },
    [formik],
  );

  const joinFromInviteLink = async () => {
    try {
      const requestConfig = {
        headers: {
          "X-API-Key": TENANT_CORE_API_KEY,
        },
      };
      await post(
        VYLABS_BASE_URL,
        JOIN_FROM_INVITE_LINK,
        {
          share_id: shareId || "",
        },
        requestConfig,
      );
    } catch (error) {
      console.error("joinFromInviteLink error", error);
      Toast("error", "Failed to join from invite link");
    }
  };

  const memberSignup = async () => {
    setIsLoading(true);
    setSignupEmail(formik.values.email);
    setSignupPassword(formik.values.confirmNewPassword);
    try {
      const payload = {
        email: formik.values.email || "",
        firstName: formik.values.firstname || "",
        lastName: formik.values.lastname || "",
        password: formik.values.confirmNewPassword || "",
        phone: formik.values?.phoneNumber || "",
        timezone: getTimezone(),
        userType: "INTERNAL_USER",
      };
      const response = await post(VYLABS_BASE_URL, SIGNUP_URL, payload,
        {
          _skipAuth: true, 
          headers: {
            "X-API-Key": TENANT_OTP_API_KEY,
          },
        },
      );
      localStorage.setItem("token", response?.access_token);
      localStorage.setItem("user", JSON.stringify(response?.user));
      await joinFromInviteLink();
      setSignupCompleted(true);
      Toast("success", "User Account created successfully!");
    } catch (error) {
      console.error("Signup Error:", error?.response?.data);
      Toast("error", error?.response?.data);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isSignupCompleted ? (
        <SignupCompletion />
      ) : (
        <div
          className={`signup-outer-container ${
            isDarkMode ? "no-bg-image" : ""
          }`}
        >
          <div className="signup-icon-text">
            <img
              alt="VylabsIcon"
              src={isDarkMode ? vybogTALDarkLogo : VylabsIcon}
              className="vy-labs-logo"
            />
            <div className="signup-welcome-container">
              <h2 className="signup-main-header">
                Welcome to the future of recruitment
              </h2>
              <span className="signup-side-text">
                Smarter hiring starts here. Find, evaluate, and hire talent
                faster.
              </span>
              <div className="user-join-page-outer">
                <div className="signup-outer-main-container">
                  <div className="signup-header-section">
                    <img src={accountIcon} alt="accountIcon" />
                    <div className="signup-header-texts">
                      <h2 className="signup-main-header">Join the team</h2>
                      <span className="signup-side-text">
                        Let's get started with your VybogTAL journey.
                      </span>
                    </div>
                  </div>
                  <div className="signup-fields-section">
                    <DynamicTextField
                      label={"First Name"}
                      name={"firstname"}
                      placeholder={"Enter Your First Name"}
                      value={formik.values.firstname}
                      onChange={formik.handleChange}
                      required={true}
                      error={
                        formik.errors.firstname && formik.touched.firstname
                      }
                      errorMessage={formik.errors.firstname}
                      onBlur={formik.handleBlur}
                    />
                    <DynamicTextField
                      label={"Last Name"}
                      name={"lastname"}
                      placeholder={"Enter Your Last Name"}
                      value={formik.values.lastname}
                      onChange={formik.handleChange}
                      required={true}
                      error={formik.errors.lastname && formik.touched.lastname}
                      errorMessage={formik.errors.lastname}
                      onBlur={formik.handleBlur}
                    />
                    <DynamicTextField
                      label={"Email"}
                      placeholder="Please Enter Your Email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      maxLength="50"
                      required={true}
                      error={formik.errors.email && formik.touched.email}
                      errorMessage={formik.errors.email}
                      onBlur={formik.handleBlur}
                    />
                    <PhoneNumberInput
                      value={formik.values.phoneNumber}
                      onChange={handlePhoneInputChange}
                      onBlur={formik.handleBlur}
                      error={formik.errors.phoneNumber}
                      touched={formik.touched.phoneNumber}
                      placeholder="Phone Number"
                      label="Phone Number"
                      height="41px"
                      countryListWidth="200px"
                      phoneContainerStyle={{ marginBottom: "14px" }}
                      required={true}
                      format="international"
                      enableSearch={true}
                      autoFormat={true}
                    />
                    <DynamicTextField
                      type={"password"}
                      label={"New Password"}
                      placeholder="Enter Your New Password"
                      name="newpassword"
                      value={formik.values.newpassword}
                      onChange={formik.handleChange}
                      showPasswordToggle={true}
                      required={true}
                      error={
                        formik.errors.newpassword && formik.touched.newpassword
                      }
                      errorMessage={formik.errors.newpassword}
                      onBlur={formik.handleBlur}
                    />
                    <DynamicTextField
                      type={"password"}
                      label={"Confirm New Password"}
                      placeholder="Re-enter Your New Password"
                      name="confirmNewPassword"
                      value={formik.values.confirmNewPassword}
                      onChange={formik.handleChange}
                      showPasswordToggle={true}
                      required={true}
                      error={
                        formik.errors.confirmNewPassword &&
                        formik.touched.confirmNewPassword
                      }
                      errorMessage={formik.errors.confirmNewPassword}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div className="join-button-container">
                    <Button
                      label={isLoading ? "Signing In..." : "Sign Up & Join"}
                      event={formik.handleSubmit}
                      iconPosition="right"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UserJoinPage;
